<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">Marcas</h1>
    </div>

    <div class="table-container">
      <div class="table-header">
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-start position-relative">
          <div class="w-full w-md-auto md-flex-1">
            <div class="d-flex justify-content-between align-items-center justify-content-lg-start">
              <button type="button" class="filter d-flex align-items-center justify-content-between border-0"
                @click="showFilters = !showFilters">
                <i class="ri-filter-3-line text-dark font-weight-bold"></i>
                <div>Filtrar</div>
              </button>

              <div class="d-md-none">
                <button type="button" class="button-tooltip text-dark font-weight-bold m-0" v-b-tooltip.hover
                  title="Recargar" @click="loadData()">
                  <i class="ri-loop-right-line"></i>
                </button>

                <button type="button" class="button-tooltip text-dark font-weight-bold" v-b-tooltip.hover
                  title="Descargar" @click="download()">
                  <i class="ri-download-2-line"></i>
                </button>
              </div>
            </div>
          </div>

          <section class="w-full w-md-auto md-flex-1 d-flex justify-content-end align-items-center mt-2 mt-md-0">
            <div class="d-none d-md-flex">
              <button type="button" class="button-tooltip text-dark font-weight-bold m-0" v-b-tooltip.hover
                title="Recargar" @click="loadData()">
                <i class="ri-loop-right-line"></i>
              </button>

              <button type="button" class="button-tooltip text-dark font-weight-bold" v-b-tooltip.hover
                title="Descargar" @click="download()">
                <i class="ri-download-2-line"></i>
              </button>
            </div>

            <div class="w-full w-md-auto d-flex flex-column flex-md-row">
              <SearchBar placeholder="Buscar por usuario o nombres y apellidos" @search="onSearch"
                @input="search = $event" class="flex-1" />

              <div class="text-right mt-2 mt-md-0">
                <b-button :to="{ name: 'brands-create' }" variant="none"
                  class="button button-primary ml-md-2">Agregar</b-button>
              </div>
            </div>
          </section>

          <filter-menu :show="showFilters" @hide="showFilters = false" :options="filterOptions"
            :selectedOptionFilter="filters" @setFilters="setFilters"></filter-menu>
        </div>

        <div class="w-100 d-flex flex-wrap align-items-center mt-2" v-if="showFiltersList">
          <span v-for="(val, name) in filterList" v-bind:key="name" class="filter-item">
            {{ getFilterName(name, val) }}
            <button type="button" class="text-white p-0 bg-transparent border-0 ml-2" @click="deleteFilter(name)">
              <i class="ri-close-circle-line"></i>
            </button>
          </span>
        </div>
      </div>

      <div>
        <!-- Mobile -->
        <div class="custom-table-mobile d-xl-none">
          <section class="custom-table-mobile-header">
            <div>
              <span>R.U.C</span>
            </div>

            <div>
              <span>Razón social</span>
            </div>
          </section>

          <div class="custom-table-mobile-body">
            <div class="custom-table-mobile-row" v-for="o in list" :key="o.id">
              <div class="custom-table-mobile-grid">
                <div>
                  <span>{{ o.identifier }}</span>
                </div>

                <div>
                  <span>{{ o.name }}</span>
                </div>

                <div>
                  <button type="button" class="border-0 bg-transparent" @click="o.showMobileData = !o.showMobileData">
                    <span v-if="!o.showMobileData">
                      <i class="ri-arrow-down-s-line"></i>
                    </span>
                    <span v-else>
                      <i class="ri-arrow-up-s-line"></i>
                    </span>
                  </button>
                </div>
              </div>

              <div class="custom-table-mobile-options mt-3">
                <router-link :to="{
                  name: 'brands-edit',
                  params: { id: o.id },
                }" class="mr-2">
                  Editar
                </router-link>
              </div>

              <div class="pt-3" v-if="o.showMobileData">
                <ul class="list-unstyled p-0">
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2">Marca comercial:</span>
                    <span>{{ o.tradeName }}</span>
                  </li>

                  <li>
                    <span class="font-weight-medium d-inline-block mr-2">Persona de contacto:</span>
                    <span>{{ o.contact || '-' }}</span>
                  </li>

                  <li>
                    <span class="font-weight-medium d-inline-block mr-2">Celular:</span>
                    <span>{{ o.mobile || "-" }}</span>
                  </li>

                  <li>
                    <span class="font-weight-medium d-inline-block mr-2">Correo electrónico:</span>
                    <span>{{ o.email || "-" }}</span>
                  </li>
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2">Estado:</span>
                    <span :class="`badge ${getStatus(o.status).color}`">{{
                      getStatus(o.status).label
                    }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop -->
        <table class="custom-table w-100 d-none d-xl-table">
          <thead>
            <tr>
              <th>R.U.C</th>
              <th>Razón social</th>
              <th>
                Marca comercial
              </th>
              <th>Persona de contacto</th>
              <th>Celular</th>
              <th>
                Correo electrónico
              </th>
              <th>Estado</th>
              <th class="pr-md-4">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="o in list" :key="o.id">
              <td class="text-center">{{ o.identifier }}</td>
              <td>{{ o.name }}</td>
              <td>{{ o.tradeName }}</td>
              <td>
                {{ `${o.contact}` }}
              </td>
              <td class="text-center">{{ o.mobile }}</td>
              <td class="text-center">{{ o.email }}</td>
              <td class="text-center">
                <span :class="`badge ${getStatus(o.status).color}`">{{
                  getStatus(o.status).label
                }}</span>
              </td>
              <td class="text-center d_option pr-md-3">
                <DropdownTable>
                  <template slot="dropdown-content">
                    <DropdownItem @click="
                      $router.push({
                        name: 'brands-edit',
                        params: { id: o.id },
                      })
                      " text="Editar" />

                    <DropdownItem :text="getStatus(o.status).action" @click="openChangeStatus(o)" />

                    <DropdownItem text="Eliminar" @click="openDelete(o)" />
                  </template>
                </DropdownTable>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-footer d-flex justify-content-end align-items-center">
        <pagination :total="total" :page="page" :page-size="pageSize" :pages="pages" :changePage="changePage"
          :changePageSize="changePageSize" v-if="list.length" />

        <div class="table-no-results" v-else>
          <p class="m-0 px-3">No se encontraron resultados.</p>
        </div>
      </div>
    </div>

    <ConfirmationModal :show="confirmationModal.show" @hide="closeConfirmationModal" :data="confirmationModal"
      @confirm="confirmModal" />
  </div>
</template>

<script>
import fileDownload from "js-file-download"

import { BrandService } from "@/core/services";
import { Constants as LocalConstants } from '@/core/utils'

import {
  Alert,
  Constants,
  Util,
  PaginationMixin,
  DropdownTable,
  DropdownItem,
  SearchBar,
  FilterMenu,
  FilterMixin,
  ConfirmationModal,
  ConfirmationModalMixin
} from "wize-admin";
import { mapGetters } from 'vuex';

export default {
  components: {
    SearchBar,
    FilterMenu,
    DropdownTable,
    DropdownItem,
    ConfirmationModal
  },
  mixins: [PaginationMixin, FilterMixin, ConfirmationModalMixin],
  data() {
    return {
      webUrl: process.env.VUE_APP_WEB_URL,
      list: [],
      tooltipType: null,
      filterOptions: [
        {
          label: "Estado",
          key: "status",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.BrandsStatus.ACTIVE,
            LocalConstants.BrandsStatus.INACTIVE
          ],
        }
      ],
    };
  },
  methods: {
    openDelete(o) {
      this.selectedOption = o;
      this.openConfirmationModal({ acceptText: "Borrar", action: "delete" });
    },
    async loadData() {
      try {
        await this.$store.dispatch("app/loading", true);

        const params = { page: this.page - 1, size: this.pageSize };
        const data = { search: this.search, ...this.filters };

        const response = await BrandService.list(data, params);

        this.list = response.payload.content.map((item) => {
          return {
            ...item,
            showMobileData: false,
          };
        })

        this.total = response.payload.totalElements;
        this.pages = response.payload.totalPages;
      } catch (error) {
        console.log(Alert);
        console.log(error);
        Alert.error(error);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    getStatus(key) {
      return Util.searchValue(key, LocalConstants.BrandsStatus);
    },
    async download() {
      try {
        await this.$store.dispatch("app/loading", true);
        const params = {
          search: this.search,
          ...this.filters,
        };
        const response = await BrandService.downloadList(params);
        fileDownload(response.data, Util.getFileName(response));
      } catch (error) {
        Alert.error(error);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    openChangeStatus(o) {
      this.selectedOption = o;
      this.openConfirmationModal({
        title: "Cambiar estado",
        description: "¿Está seguro que desea cambiar el estado?",
        acceptText: "Aceptar",
        action: "update",
      });
    },
    confirmModal() {
      this.closeConfirmationModal();
      if (this.confirmationModal.action === "update") this.changeStatus();
      if (this.confirmationModal.action === "delete") this.deleteItem()
    },
    async changeStatus() {
      try {
        await this.$store.dispatch("app/loading", true);

        let status = this.selectedOption.status;

        if (status == LocalConstants.BrandsStatus.ACTIVE.key) {
          status = LocalConstants.BrandsStatus.INACTIVE.key;
        } else if (status == LocalConstants.BrandsStatus.INACTIVE.key) {
          status = LocalConstants.BrandsStatus.ACTIVE.key;
        }
        await BrandService.toggleStatus(this.selectedOption.id, status);
        await this.loadData();
        Alert.success("Estado actualizado correctamente");
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors.message);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    async deleteItem() {
      try {
        await this.$store.dispatch("app/loading", true);
        await BrandService.delete(
          this.selectedOption.id
        );

        Alert.success("Marca eliminada correctamente");

        await this.loadData();
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors.message);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    }
  },
  async mounted() {
    await this.loadData();
  },
  computed: {
    ...mapGetters({
      business: 'app/getBusiness'
    })
  }
};
</script>

<style lang="stylus" scoped></style>
